<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card >
      <div v-if="selected" >
        <div class="text-center">
        <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <br>
             <br>
              <br>
        </div>

        <form>
          <div class="etkinlikIcerigi" v-if="taskOff">
      <vs-title  back>Etkinlikle İlgili Öneri/Şikayet/Talepler</vs-title>
       <v-divider  class="divider" inset></v-divider>
      
        <v-radio-group
      v-model="obj.columns.science"
      row
      label="Etkinliğin Bilimsel Katkısı"
    >
    <div class="radio1" >
      <v-radio
        label="Var"
        value="Var"
      ></v-radio>
      </div>
      <div class="radio2">
      <v-radio
       label="Yok"
        value="Yok"
      ></v-radio>
       </div>
    </v-radio-group>
 
         
         <br/>
        
        
       
      
       <br/>
        <br/>
         <br/>
          <br/>
        
       
    </v-radio-group>

         
      
     

        </div>

         <br/>
        <br/>
        
      
          
          
        
        </form>
        <div v-if="taskOff">
        <vs-error :errors="errors"></vs-error>

       

       

        <vs-button class="butonlar" color="success" @click="update">Güncelle</vs-button>
         <vs-button class="butonlar" color="danger" @click="deleteItem">Sil</vs-button>
         
        <p>{{ message }}</p>
      </div>
        </div>
        
      <div v-else>
        <div slot="header">
          <vs-title back>Etkinlik Seçili Değil</vs-title>
        </div>

        <p>Etkinlik Seçiniz...</p>
      </div>
    </vs-card>
  </div>

</template>

<script>
  import Appeal from "@/libs/appeals/Appeal";

  export default {
    name: "admincomps-create",
    title: "Etkinlik Görüntüle/Düzenle",

    data() {
      return {
        obj: new Appeal(),
        iliskiler:'',
        dene:'',
        loading: false,
        taskOn: false,
        sustainable: false,
        fileUpload: false,
        taskOff: true,
        message: '',
        menu2: false,
        color1:"#c94c4c",
        color2:"#feb236",
        color3:"#82b74b",
        color4:"#c94c4c",
        color5:"#F65314",
        color6:"#00A1F1",
        color7:"#FFBB00",
        color8:"#c83349",
        color9:"#F65314",
        color10:"#e06377",
        color11:"#ffcc5c",
        color12:"#8b6f47",
        color13:"#405d27",
        color14:"#00A1F1",
        color15:"#82b74b",
        color16:"#6b5b95",
        color17:"#36486b",
      popupActivo1:false,
      popupActivo2:false,
      popupActivo3:false,
      popupActivo4:false,
      popupActivo5:false,
      popupActivo6:false,
      popupActivo7:false,
      popupActivo8:false,
      popupActivo9:false,
      popupActivo10:false,
      popupActivo11:false,
      popupActivo12:false,
      popupActivo13:false,
      popupActivo14:false,
      popupActivo15:false,
      popupActivo16:false,
      popupActivo17:false,
      select1Normal:'',
      repeat:0,
      select1:[],
      selectedLanguages:[],
      langs:'',
      languages2:[
        {text: 'Türkçe', value: 'Türkçe'},
        {text: 'İngilizce', value: 'İngilizce'},
        {text: 'Almanca', value: 'Almanca'},
        {text: 'İtalyanca', value: 'İtalyanca'},
        {text: 'İspanyolca', value: 'İspanyolca'},
        {text: 'Fransızca', value: 'Fransızca'},
        {text: 'Arapça', value: 'Arapça'},
        
      ],
      options3:[
        {text: 'Konser', value: 'Konser'},
        {text: 'Sergi', value: 'Sergi'},
        {text: 'Tiyatro', value: 'Tiyatro'},
        {text: 'Sinema', value: 'Sinema'}
       
      ],
       gorevler:[
        {text: 'Yönetici', value: 'Yönetici'},
        {text: 'Sunucu', value: 'Sunucu'},
        {text: 'İzleyici', value: 'İzleyici'},
       
      ],
      paraBirimi:[
        {text: '₺ Türk Lirası', value: 'Türk Lirası'},
        {text: '$ Dolar', value: 'Dolar'},
        {text: '€ Euro', value: 'Euro'},
        {text: '£ Sterlin', value: 'Sterlin'}
       
      ],
      };
    },

    computed: {
      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      },

      errors() {
        return this.obj.form.errors
      },

      selected() {
        return this.obj.selected
      },
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.message = 'Etkinlik Başarıyla Güncellendi!';
      },

      deleted(val) {
        if(val)
          this.$router.go(-1) // back
      },
    },

    methods: {
      uploadFile (event) {
        this.files = event.target.files
        },
        handleSubmit() {
          const formData = new FormData();
          for (const i of Object.keys(this.files)) {
            formData.append('files', this.files[i])
          }
            formData.append('directory', this.selected.eventName)
           formData.append('dclass', 'etkinlik_sonlandir')
          
          axios.post('https://eys.hacibayram.edu.tr:8081/api/file-upload', formData, {
          }).then((res) => {
            console.log(res)
          })
        } ,
      deneme(){
        console.log(this.obj.columns.eventType);
        console.log(this.obj.columns.eventTask);
      },
      get(id) {
        this.obj.get(id, true);
      },

      updatePublished(status) {
        this.obj.columns.published = status
        return this.update()
      },
       updateTask() {
        if(this.taskOn==true){
          console.log("tr")
          this.taskOn=false;
          this.taskOff=true;
        }
        else{
          this.taskOn=true;
          this.taskOff=false;
        }
      },
       updateFileArea() {
        if(this.fileUpload==true){
          console.log("tr")
          this.fileUpload=false;
          this.taskOff=true;
        }
        else{
         
          this.fileUpload=true;
          this.taskOff=false;
        }
      },
      updateSustain() {
        if(this.sustainable==true){
          console.log("tr")
          this.sustainable=false;
          this.taskOff=true;
        }
        else{
          
          this.sustainable=true;
          this.taskOff=false;
        }
      },
      update() {
        
        this.loading = true
        
        
        this.obj.update(this.selected.id, true)
      },

      deleteItem() {
        this.loading = true
        this.obj.delete(this.selected.id)
       
      }
    },

    mounted() {
      this.message = '';
      this.dene= this.$route.params.id 
     
       console.log(this.dene)
    }
  };
</script>

<style>
  .edit-form {
    max-width: 70%;
    margin: auto;
  }
  .element1 {display:inline-block;margin-right:10px;} 
.element2 {display:inline-block;} 
.element3 {display:inline-block;margin-right:100px; border-style: solid;
  border-width: 5px;} 
.element4 {display:inline-block; border-style: solid;
  border-width: 5px;} 
.sayfa1 {margin-left:5%;} 
.etkinlikIcerigi{
  margin-left:5%;
}
.sayfa2 {margin-left:5%;} 
.mainTitle{
  font-size: 22px;
  color: #666;
  margin: 20px 10px 0px;
  padding: 0px 30px 0px 30px;
  text-align: center;
  
}
.divider{
  background-color:#441468; height:7px; width:100%
}
.counter{
  max-width: 30%;
}
.para{
  display: inline-block;
}
.select{
  width:100% !important;
}
.xyz{
  width:100% !important;
}
.radio1{
  margin-left: 30%;
}
.radio2{
  margin-left: 5%;
}
.repeat {
  display: inline-block; /* the default for span */
 margin-left: 15%;
 
 

}
.avesis {
  display: inline-block; /* the default for span */
  margin-left: 12%;
  width:30%;
}

.butonBoyut{
width:90%;
}
.katilimEtkinlikHedef{
  margin-left:20%;
}

.dosyaYukleme{
 margin-left:25%;
 width:30%;
}
.pop {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop2 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop3 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop4 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop5 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop6 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop7 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop8 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop9 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop10 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop11 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop12 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop13 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop14 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop15 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop16 {
  display:inline-block;
  padding: 10px;
  color:white;
}
.pop17 {
  display:inline-block;
  padding: 10px;
  color:white;
}

.vs-component.vs-button.vs-button-null.vs-button-filled {
   
}
.dosyaTemaKonu{
  margin-left:36%;
}
.jlist{
  width: 40%;
}
.con-input-upload{
  height: 60px;
  width: 150px;
   content:'goodbye'; 
}
.vs-select--label{
  font-weight: bold;
}
.v-label.theme--light{
  font-weight: bold;
}
.input-select-con{
  font-weight: bold;
}
.vs-con-input{
  font-weight: bold;
}
.butonlar{
  margin-left:1%;
}
#parameter{
   height:150px;
    width:170px;
    font-family: "Gill Sans", sans-serif;
    font-weight: 520;
}
#parameterİliski{
   font-weight: bold;
   border-style: solid;
  border-width: 5px;
  margin-top:15px;
}
.iliskiBorder{
  border-style: solid;
  border-width: 2px;
  border-radius:5px;
 
}
#parentt {
   margin-left:15%;
   
}
.childd {
    display: inline-block;
    width: 25%;
    height: 100%;
      font-weight: bold;

    
}
.childd2 {
    display: inline-block;
      font-weight: bold;

    width: 25%;
    margin-bottom:20px;
    
}
.childdd3{
    
    margin-left:15%;
    
}
.videolink{
   width: 67%;
}
</style>